import React, { useEffect, useState } from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { graphql, useStaticQuery } from "gatsby";
import styled from "styled-components";

import SidebarGoogleAds from "components/shared/SidebarGoogleAds";


const StyledAdsBlock = styled.section`
  width: 100%;
  text-align: center;
  padding-bottom: 1rem;
  a {
    &:nth-child(1) {
      margin-bottom: 1rem;
    }
  }
`;

const StaticAds = ({ data }) => (
  <StyledAdsBlock>
      <a
        href={data.squareLink?.url}
        target={data.squareLink?.target}
        rel="noopener noreferrer"
        className="pb-2"
      >
        <div className="square">
          <GatsbyImage
            image={data.squareImage?.localFile.childImageSharp.gatsbyImageData}
            alt={data.squareImage?.altText}
          />
        </div>
      </a>
      <a
        href={data.rectangleLink?.url}
        target={data.rectangleLink?.target}
        rel="noopener noreferrer"
        className="pb-2"
      >
        <div className="rectangle">
          <GatsbyImage
            image={
              data.rectangleImage?.localFile.childImageSharp.gatsbyImageData
            }
            alt={data.rectangleImage?.altText}
          />
        </div>
      </a>
    </StyledAdsBlock>
);

export default function SidebarAds({ data, googleAdsSidebar }) {
  const [activeAds, setActiveAds] = useState("");
  const [adsData, setAdsData] = useState({});
  const { global } = useStaticQuery(graphql`
    query {
      global: allWp {
        edges {
          node {
            options {
              acfOptions {
                squareLink {
                  target
                  url
                  title
                }
                rectangleLink {
                  target
                  url
                  title
                }
                rectangleImage {
                  altText
                  sourceUrl
                  localFile {
                    childImageSharp {
                      gatsbyImageData(
                        width: 300
                        height: 600
                        quality: 90
                        placeholder: NONE
                        layout: CONSTRAINED
                      )
                    }
                  }
                }
                squareImage {
                  altText
                  sourceUrl
                  localFile {
                    childImageSharp {
                      gatsbyImageData(
                        width: 300
                        height: 250
                        quality: 90
                        placeholder: NONE
                        layout: CONSTRAINED
                      )
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `);
  const globalAds = global?.edges[0]?.node?.options.acfOptions;
  useEffect(() => {
    if (
      Object.values(data).every((value) => value === null) &&
      Object.values(globalAds).every((value) => value === null)
    ) {
      setActiveAds("pageGoogleAds");
    } else {
      if (data.rectangleLink && data.rectangleImage ||  data.squareImage && data.squareLink) {
        setActiveAds("staticPageAds");
        setAdsData(data);
      } else {
        setActiveAds("staticGlobalPageAds");
        setAdsData(globalAds);
      }
    }
  }, []);

  switch (activeAds) {
    case "staticPageAds":
      return <StaticAds data={adsData} />;
    case "staticGlobalPageAds":
      return <StaticAds data={adsData} />;
    case "pageGoogleAds":
      return <SidebarGoogleAds googleAdsSidebar={googleAdsSidebar} />;
    default:
      return "";
  }
}


